import React from "react";
import LectionItem from "./lection-item";

const LectionList = ({ sections, courseId }) => {
  return (
    <div className="lection-list">
      {sections.map((section) => (
        <LectionItem
          section={section}
          key={section.id}
          courseId={courseId}
         />
      ))}
    </div>
  )
};

export default LectionList;